import { Progress as MantineProgress, ProgressProps as MantineProgressProps } from "@mantine/core";

export type ProgressProps = MantineProgressProps

export const Progress = (props: ProgressProps) => {
  const { ...rest } = props;
  return <MantineProgress {...rest} />;
};
